import { useRef } from "react";

export const useMultiRef = (defaultParent, defaultChildren) => {
    let parent = useRef([]);
    let children = useRef([]);

    if (defaultParent) {
        parent.current = defaultParent;
    }

    if (defaultChildren) {
        children.current = defaultChildren;
    }

    return { parent, children };
};
